{
  "appointment": {
    "CONFIRMATION_NUMBER": "確認號碼",
    "APPOINTMENT_ID": "預約 ID",
    "APPOINTMENT_DATE": "預約日期",
    "APPOINTMENT_TIME": "預約時間",
    "APPOINTMENT_TIMEZONE": "時區",
    "APPOINTMENT_TYPE": "預約類型",
    "SCHEDULED_DURATION": "排定時長（分鐘）",
    "STATUS": "狀態",
    "ARRIVAL_DATE": "抵達日期",
    "ARRIVAL_TIME": "抵達時間",
    "DEPARTURE_DATE": "離開日期",
    "DEPARTURE_TIME": "離開時間",
    "DWELL_TIME": "停留時間（分鐘）",
    "ON_TIME": "準時差異（分鐘）",
    "IN_PROGRESS_DATE": "作業中日期",
    "IN_PROGRESS_TIME": "作業中時間",
    "WAIT_TIME": "等候時間（分鐘）",
    "PROCESSING_TIME": "處理時間（分鐘）",
    "WAREHOUSE": "倉庫",
    "DOCK": "月台",
    "LOAD_TYPE": "貨物類型",
    "LOAD_TYPE_DIRECTION": "方向",
    "RESCHEDULE_COUNT": "重新安排次數",
    "CREATED_BY": "建立者",
    "CREATOR_TYPE": "建立者類型",
    "CREATION_DATE": "建立日期",
    "LAST_UPDATED_BY": "最後更新者",
    "LAST_UPDATE_DATE": "最後更新日期",
    "LAST_UPDATE_TIME": "最後更新時間",
    "CARRIER_COMPANY": "承運公司",
    "CONTACT_NAME": "聯絡人姓名",
    "CONTACT_EMAIL": "聯絡人電子郵件",
    "CONTACT_PHONE": "聯絡人電話",
    "NOTES": "備註",
    "TAGS": "標籤",
    "CUSTOM_FIELDS": "自訂欄位",
    "EXTERNAL_VALIDATION_STATUS": "外部驗證狀態",
    "EXTERNAL_VALIDATION_ERROR_MESSAGE": "外部驗證錯誤訊息",
    "CheckOut": "離場登記",
    "CheckInAdditionalAssetDetails": "報到其他資產詳細資料",
    "InboundClaim": "進貨索賠",
    "OutboundClaim": "出貨索賠",
    "BookLoadType": "預約貨物類型",
    "AssetContainerDetails": "資產貨櫃詳細資料",
    "AppointmentCompleted": "預約已完成"
  },
  "assetVisit": {
    "id": "到訪 ID",
    "appointmentId": "預約 ID",
    "checkInDate": "報到日期/時間",
    "checkOutDate": "離場日期/時間",
    "carrier": "承運商",
    "warehouseName": "倉庫",
    "currentStatus": "狀態",
    "licensePlate": "車牌號碼",
    "visitType": "到訪類型",
    "dotNumber": "DOT 編號",
    "phone": "電話",
    "isPlanned": "已排定",
    "driverNotes": "司機備註",
    "checkInAcknowledged": "已確認報到",
    "firstName": "身分驗證名字",
    "lastName": "身分驗證姓氏",
    "birthdate": "身分驗證出生日期",
    "idValidationEmail": "身分驗證電子郵件",
    "idValidationPhone": "身分驗證電話"
  }
}
